"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _App = _interopRequireDefault(require("./App"));

var _Auth = _interopRequireDefault(require("./Auth"));

var _Clips = _interopRequireDefault(require("./Clips"));

var _ClipsFilter = _interopRequireDefault(require("./ClipsFilter"));

var _redux = require("redux");

var _ComposerSettings = _interopRequireDefault(require("./ComposerSettings"));

var _Composition = _interopRequireDefault(require("./Composition"));

var _Conversations = _interopRequireDefault(require("./Conversations"));

var _GoogleDocs = _interopRequireDefault(require("./GoogleDocs"));

var _Lock = _interopRequireDefault(require("./Lock"));

var _Pages = _interopRequireDefault(require("./Pages"));

var _Presence = _interopRequireDefault(require("./Presence"));

var _Revisions = _interopRequireDefault(require("./Revisions"));

var _Save = _interopRequireDefault(require("./Save"));

var _Toasts = _interopRequireDefault(require("./Toasts"));

var _UISettings = _interopRequireDefault(require("./UISettings"));

var _Users = _interopRequireDefault(require("./Users"));

var _UserAttributes = _interopRequireDefault(require("./UserAttributes"));

var _default = (0, _redux.combineReducers)({
  app: _App.default,
  auth: _Auth.default,
  clips: _Clips.default,
  clipsFilter: _ClipsFilter.default,
  composerSettings: _ComposerSettings.default,
  composition: _Composition.default,
  conversations: _Conversations.default,
  googleDocs: _GoogleDocs.default,
  lock: _Lock.default,
  pages: _Pages.default,
  presence: _Presence.default,
  revisions: _Revisions.default,
  save: _Save.default,
  toasts: _Toasts.default,
  uiSettings: _UISettings.default,
  users: _Users.default,
  userAttributes: _UserAttributes.default
});

exports.default = _default;
module.exports = exports.default;